var React = require('react');

function FacebookFill (props) {
    return React.createElement("svg",props,[React.createElement("title",{"id":"facebook-f1","key":0},"facebook-f icon"),React.createElement("g",{"id":"facebook-f1_layer","key":1},React.createElement("path",{"d":"M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"}))]);
}

FacebookFill.defaultProps = {"version":"1.0","viewBox":"0 0 264 512","aria-labelledby":"facebook-f1","role":"img"};

module.exports = FacebookFill;

FacebookFill.default = FacebookFill;
